import { render, staticRenderFns } from "./_SingleProduct.vue?vue&type=template&id=2e0cab19&scoped=true&"
import script from "./_SingleProduct.vue?vue&type=script&lang=js&"
export * from "./_SingleProduct.vue?vue&type=script&lang=js&"
import style0 from "./_SingleProduct.vue?vue&type=style&index=0&id=2e0cab19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0cab19",
  null
  
)

export default component.exports